/** @flow */

export default {
  en: {
    CHECKBOX_GROUP_ALL_QUESTIONS_SELECTED: "All {count} selected.",
    CHECKBOX_GROUP_SELECT_QUESTIONS: "Select {count} quesitons.",
    CHECKBOX_GROUP_SELECT_MORE: "Select {count} more.",
    CHECKBOX_GROUP_CLEAR_SELECTION: "Clear Selection",
    CHECKBOX_GROUP_TOOLTIP_DATA:
      "The maximum of {count} questions is already selected. Please deselect a question to select another.",
  },
};
